import { useEffect } from "react";
import Email from "@/assets/icons/Email";
import Info from "@/assets/icons/Info";
import { Button } from "@/components/shared/Button/Button";
import Title from "@/components/shared/Title/Title";
import { Alert, AlertDescription } from "@/components/ui/alert";
import LayoutOutside from "@/layout/LayoutOutside";
import { useTranslation } from "react-i18next";
import { useEmailConfirmation } from "./hooks/useVerifyEmail";
import { useAuth } from "@/auth/Auth";
import Loader from "@/components/Loader/Loader";

export default function VerifyEmail() {
  const { t } = useTranslation("common");
  const { timeLeft, isButtonDisabled, isLoading, handleResendEmail } =
    useEmailConfirmation();
  const { signOut, authData } = useAuth();

  const displayEmail =
    authData?.email ||
    (() => {
      try {
        const stored = localStorage.getItem("@email");
        return stored ? JSON.parse(stored) : "";
      } catch {
        return "";
      }
    })();

  useEffect(() => {
    document.body.classList.add("no-scroll");
    return () => {
      document.body.classList.remove("no-scroll");
    };
  }, []);

  return (
    <LayoutOutside
      logout={signOut}
      text={t("backToLogin")}
      classNameMainContainer="h-screen overflow-hidden"
    >
      <section className="text-colorText space-y-8 max-w-[328px] w-full text-center flex flex-col items-center">
        {isLoading ? <Loader /> : <Email />}
        <div className="space-y-5">
          <Title text={t("verifyEmail")} />
          <p className="font-medium text-[#a1a1aa]">
            {t("subtitle1")}
            {displayEmail ? (
              <>
                {" "}
                <strong className="text-colorText">{displayEmail}</strong>.
              </>
            ) : null}
            {t("subtitle2")}
          </p>
        </div>
        <Button
          variant="link"
          onClick={handleResendEmail}
          disabled={isButtonDisabled}
        >
          {isButtonDisabled ? `${t("resend")} ${timeLeft}` : t("resend")}
        </Button>
        <div className="border-b w-full border-b-colorBorder" />

        <Alert variant="info" className="text-start">
          <Info color="#fafafa" />
          <AlertDescription>{t("no_email")}</AlertDescription>
        </Alert>
      </section>
    </LayoutOutside>
  );
}
